import { SettlementMarketItem } from '@app/shared/ui/molecules/Settlements';
import { SETTLEMENT_MARKET } from '@app/shared/constants/settlements';

interface SettlementMarketListProps {
  onSettlementClick: (value: string) => void;
}

export function SettlementMarketList({ onSettlementClick }: SettlementMarketListProps) {
  return (
    <div className="mb-16 grid grid-cols-2 gap-4">
      {SETTLEMENT_MARKET.map((settlement, index) => (
        <SettlementMarketItem
          key={`${settlement.name}${String(index)}`}
          icon={settlement.icon}
          name={settlement.name}
          tonAmount={settlement.ton}
          onSettlementCLick={onSettlementClick}
        />
      ))}
    </div>
  );
}
